import React from "react";
import { DA_Checkbox } from "@danishagro/shared/src/components/atoms/Checkbox/Checkbox.component";
import { DA_Input } from "@danishagro/shared/src/components/atoms/Input/Input.component";
import { DA_InputWrapper } from "@danishagro/shared/src/components/atoms/InputWrapper/InputWrapper.component";
import { DA_Text } from "@danishagro/shared/src/components/atoms/Text/Text.component";
import { DynamicFieldProps } from "./DynamicField.interface";
import S from "./DynamicField.module.scss";

export const DynamicField = (props: DynamicFieldProps) => {
    const { field, formData, getError, onInputChange } = props;

    // Error message
    const fieldError = getError(field.alias);

    // Label
    const getLabel = () => {
        if (!field.settings.ShowLabel || field.settings.ShowLabel === "False") return;

        // Indicator
        let indicator = "";
        if (formData.fieldIndicationType === 1 && field.mandatory) indicator = formData.indicator;
        else if (formData.fieldIndicationType === 2 && !field.mandatory)
            indicator = formData.indicator;

        return `${field.caption} ${indicator}`;
    };

    return (
        <>
            {/** Hidden */}
            {field.fieldTypeId === "da206cae-1c52-434e-b21a-4a7c198af877" ? (
                <DA_Input
                    name={field.alias}
                    type="hidden"
                    title={field.caption}
                    defaultValue={field.settings.DefaultValue && field.settings.DefaultValue}
                    className={S.hiddenInput}
                />
            ) : null}

            {/** Data consent (checkbox) */}
            {field.fieldTypeId === "a72c9df9-3847-47cf-afb8-b86773fd12cd" ? (
                <DA_InputWrapper
                    forId={undefined}
                    label={getLabel()}
                    invalid={fieldError ? true : false}
                    helperText={fieldError?.message}
                    tooltip={field.toolTip}
                    className={fieldError ? S.invalid : null}
                >
                    <DA_Checkbox
                        name={field.alias}
                        label={<DA_Text html={field.settings.AcceptCopy} noPadding />}
                        placeholder={field.settings.Placeholder}
                        value="on"
                        onChange={() => onInputChange(field.alias)}
                        className={fieldError ? S.invalid : null}
                    />
                </DA_InputWrapper>
            ) : null}
        </>
    );
};
